import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router';

import { get, includes } from 'lodash';

import { useCurrentUser } from '@lib/hooks';
import { RolloutEnum } from '@lib/resources/types';

import WidgetLumaBotV2Wrapper from '../LumaBotV2/widgets/WidgetLumaBotWrapper';

import WidgetLumaBotWrapper from './widgets/WidgetLumaBotWrapper';

interface LumaBotVersioningProps extends RouteComponentProps<null, null> {}

const LumaBotVersioning: React.FC<LumaBotVersioningProps> = ({ ...props }) => {
  const [isLumaBotV1, setLumaBotV1] = useState(false);
  const currentUser = useCurrentUser();

  useEffect(() => {
    if (!currentUser) return;
    const currentUserRollouts: RolloutEnum[] = get(currentUser, 'rollouts', []);
    setLumaBotV1(includes(currentUserRollouts, RolloutEnum.LumaBotV1));
  }, [setLumaBotV1, currentUser]);

  if (!isLumaBotV1) return <WidgetLumaBotV2Wrapper {...props} />;

  return <WidgetLumaBotWrapper {...props} />;
};

export default LumaBotVersioning;
